/**
 * @file Pipe used for humanizing a duration value
 * @author Willem Jan Weitering
 */
import { PipeTransform } from '@angular/core';
import { durationToText } from '../../core/helpers/durationToText';
/**
 * The class for duration to text functionality
 */
var DurationToTextPipe = /** @class */ (function () {
    function DurationToTextPipe() {
    }
    /**
     * Humanize a duration value
    * @param {moment.Duration} duration The duration value.
    * @returns {string} The duration in HH:nn format.
    */
    DurationToTextPipe.prototype.transform = function (duration) {
        return durationToText(duration);
    };
    return DurationToTextPipe;
}());
export { DurationToTextPipe };
